import RegisterFutureInfoForm from './register-future-info-form';

export default RegisterFutureInfoForm;
